import { URLS } from "@app/shared";
import { PageHeader, ReadMoreText } from "@design-system/components";
import { trans } from "@mongez/localization";
import { InvestmentCase } from "../components";

export function SenaatAndInvestmentCasePage() {
  return (
    <>
      <PageHeader
        translationKey="senaatAndInvestmentCase"
        breadcrumbItems={[
          { label: trans("home"), link: URLS.home },
          { label: trans("investorRelations"), link: URLS.investor.root },
          { label: trans("senaatAndInvestmentCase") },
        ]}
      />
      <div className="pt-12 sm:pt-16">
        <div className="container flex flex-col gap-5">
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-secondary" />
            <span className="text-sm font-semibold uppercase tracking-widest text-secondary">
              {trans("senaat")}
            </span>
          </div>
          <h2 className="text-4xl font-bold leading-tight text-marine sm:text-5xl xl:text-[3.25rem]">
            {trans("prideOfSaudiManufacturing")}
          </h2>
          <ReadMoreText className="text-base leading-relaxed text-marine/75 sm:text-xl lg:hidden">
            {trans("senaatDescription")}
          </ReadMoreText>
          <p className="hidden text-base leading-relaxed text-marine/75 sm:text-xl lg:block">
            {trans("senaatDescription")}
          </p>
        </div>
      </div>
      <InvestmentCase />
    </>
  );
}
